import { $api } from '../../global';

// Send sms in login
export const SendSmsLogin = async (phone: string) => {
  const { data } = await $api.post('/sendsms', { phone });

  return data;
};

export const CheckSmsLogin = async ({ phone, code, platform }: { phone: string; code: string; platform: string }) => {
  const { data } = await $api.post('/checksms', { phone, code, platform });

  return data;
};
